import axios from "axios";
import queryString from "query-string";

import config from "../config";

// Headers
let headers = {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    "Cache-Control": "no-cache"
};

// Create
const instance = axios.create({
    baseURL: config.apiUrl,
    timeout: 60000,
    headers: headers
});

// Request interceptor
instance.interceptors.request.use(
    function (config) {
        // Check if external request
        if (config.url.indexOf("amazonaws.com") >= 0) {
            delete config.headers["Authorization"];
        }

        // Serialize request data parameters
        else if (config.data) {
            config.data = queryString.stringify(config.data);
        }

        return config;
    },
    function (error) {
        console.log("Request error:", error);
    }
);

// Response interceptor
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        return Promise.reject(error.response);
    }
);

export default instance;
